import $ from 'jquery';

export function AffiliatesPage() {
  if (window.intervalIds) {
    window.intervalIds.forEach(clearInterval);
  }
  window.intervalIds = [];

  let isMobile = $(window).width() < 1280;
  let timeOut = !isMobile ? 500 : 0;

  // Hero animation
  $('.main-page__hero').addClass('-animated');

  // Startup animations
  setTimeout(() => {
    setTimeout(() => {
      $('#circle-1').css({
        'fill-opacity': '1',
        'filter': 'unset',
      });
    }, 0);

    setTimeout(() => {
      $('#circle-2').css({
        'fill-opacity': '1',
        'filter': 'unset',
      });
    }, 100);

    setTimeout(() => {
      $('#circle-3').css({
        'fill-opacity': '1',
        'filter': 'unset',
      });
    }, 200);

    setTimeout(() => {
      $('#circle-4').css({
        'fill-opacity': '1',
        'filter': 'unset',
      });
    }, 300);

    setTimeout(() => {
      $('#circle-5').css({
        'fill-opacity': '1',
        'filter': 'unset',
      });
    }, 400);

    setTimeout(() => {
      $('#circle-6').css({
        'fill-opacity': '1',
        'filter': 'unset',
      });
    }, 500);

    setTimeout(() => {
      $('.main-page__hero').addClass('-stop-init-animation');
    }, 1000);
  }, timeOut);
}
